import { render, staticRenderFns } from "./course-unit-card-item.vue?vue&type=template&id=1cd5600e&scoped=true"
import script from "./course-unit-card-item.vue?vue&type=script&lang=js"
export * from "./course-unit-card-item.vue?vue&type=script&lang=js"
import style0 from "./course-unit-card-item.vue?vue&type=style&index=0&id=1cd5600e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd5600e",
  null
  
)

export default component.exports